import { composeClassNames } from "@faedev/editor-utils";
import { match } from "@faedev/variant";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import BenefitList from "src/components/BenefitList";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Page from "src/components/Page";
import Preloader from "src/components/Preloader";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getDataPartner, { getDataPartners } from "src/functions/getDataPartner";
import getDefaultOg from "src/functions/getDefaultOg";
import { sPageBenefits } from "src/styles/sPageBenefits.module.scss";

export default function Benefits({ staticPartners }) {
  var { locale: lang, isFallback } = useRouter();

  var dBenefitList = match(
    getDataPartner("", lang).data,
    {
      loading: function (loading) {
        return isFallback ? null : staticPartners;
      },
      error: function (error) {
        return null;
      },
      success: function (success) {
        return success;
      },
    },
    function (type) {
      return null;
    }
  );

  return (
    <>
      <Headers data={getDefaultOg(lang)} />

      <Page className={composeClassNames([sPageBenefits, "page-benefits"])}>
        <Header />
        <Content fluid={`xxl`}>
          {dBenefitList ? (
            <BenefitList
              data={dBenefitList}
              showMore={false}
              title={<Translate tKey={`Benefits for you from our partners`} />}
            />
          ) : (
            <Preloader />
          )}
        </Content>
        <Footer />
      </Page>
      <Footers />
    </>
  );
}

export const getStaticProps: GetStaticProps = async function () {
  const partners = await getDataPartners();

  return {
    props: {
      staticPartners: partners,
    },
    revalidate: constants.RefreshIntervals.default,
  };
};
